import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import counter from "./counter";
import filter from "./filter/reducer";
import client from "./client/reducer";
import reload from "./reload/reducer";
import session from "./session/reducer";
import language from "./language/reducer";
import consignmentResult from "./consignmentResult/reducer";
import consignmentRequest from "./consignmentRequest/reducer";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    consignmentRequest,
    consignmentResult,
    language,
    session,
    counter,
    reload,
    client,
    filter,
  });
